
import Vue from 'vue';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _vm._m(0);
};
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;
    return _c('div', { staticClass: 'footer container' }, [
      _c('div', { staticClass: 'row justify-content-center pl-4 pr-4 p-md-0' }, [
        _c('div', { staticClass: 'col-1 void-column' }),
        _c('div', { staticClass: 'row col-md-11 col-12 footer-section' }, [
          _c('div', { staticClass: 'col-md-3 col-12' }, [
            _c('div', { staticClass: 'logo-footer' }),
            _c('div', { staticClass: 'col-12 footer-social-icon' }, [
              _c('a', { attrs: { href: 'https://www.instagram.com/showupproduction' } }, [
                _c('i', { staticClass: 'su-icon su-icon-instagram' }),
              ]),
              _c('a', { attrs: { href: 'https://www.facebook.com/castingshowup' } }, [
                _c('i', { staticClass: 'su-icon su-icon-facebook' }),
              ]),
              _c(
                'a',
                {
                  attrs: {
                    href: 'https://www.linkedin.com/company/show-up-productions/posts/?feedView=all',
                  },
                },
                [_c('i', { staticClass: 'su-icon su-icon-linkedn' })],
              ),
            ]),
            _c('div', { staticClass: 'col-12 company-info-footer' }, [
              _c('b', [_vm._v('Showup SRL')]),
              _c('br'),
              _vm._v(' PIVA 08144921213 '),
            ]),
          ]),
          _c('div', { staticClass: 'col-md-9 col-12' }, [
            _c('div', { staticClass: 'col-12 contacts-container-footer' }, [
              _c('div', { staticClass: 'col-md-4 col-12 icon-container' }, [
                _c('i', { staticClass: 'su-icon su-icon-location' }),
                _vm._v(' Via dei Naviganti, 10 - Torre del Greco (NA) '),
                _c('br'),
                _vm._v(' 80059 - Italy '),
              ]),
              _c('div', { staticClass: 'col-md-4 col-12 icon-container' }, [
                _c('a', { attrs: { href: 'tel:' } }, [
                  _c('i', { staticClass: 'su-icon su-icon-phone' }),
                  _vm._v(' +39 081 849 5702 '),
                ]),
              ]),
              _c('div', { staticClass: 'col-md-4 col-12 icon-container' }, [
                _c('a', { attrs: { href: 'mailto:info@show-up.it' } }, [
                  _c('i', { staticClass: 'su-icon su-icon-email' }),
                  _vm._v(' info@show-up.it '),
                ]),
              ]),
            ]),
            _c('div', { staticClass: 'col-12 d-flex flex-md-row flex-column' }, [
              _c(
                'div',
                {
                  staticClass:
                    'col-12 d-flex flex-column flex-md-row align-items-center justify-content-center',
                },
                [
                  _c(
                    'a',
                    {
                      staticClass: 'm-3',
                      attrs: { href: '/privacy-policy', title: 'Privacy Policy' },
                    },
                    [_vm._v('Privacy Policy')],
                  ),
                  _c(
                    'a',
                    {
                      staticClass: 'm-3',
                      attrs: { href: '/cookie-policy', title: 'Cookie Policy' },
                    },
                    [_vm._v('Cookie Policy')],
                  ),
                ],
              ),
            ]),
          ]),
        ]),
      ]),
    ]);
  },
];

export default Vue.extend({
  render,
  staticRenderFns,
  name: 'Footer',
  props: {},
});
